import React from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { errorMessage } from 'lib/styleguide/base.scss'
import p from 'prop-types'

export const CONFIRM_UNSET_SHOW_ROUTES = 'CONFIRM_UNSET_SHOW_ROUTES'

export class ConfirmUnsetShowRoutesDialog extends React.PureComponent {
  static propTypes = {
    onConfirm: p.func.isRequired,
    onRequestClose: p.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      updatePending: false,
      updateError: false
    }
  }

  onConfirm = () => {
    const { onConfirm, onRequestClose } = this.props

    this.setState({ updatePending: true })
    onConfirm()
      .then(onRequestClose)
      .catch(() => this.setState({ updatePending: false, updateError: true }))
  }

  render () {
    const { onRequestClose } = this.props
    const { updatePending, updateError } = this.state

    return (
      <ConfirmationDialog
        primary danger
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={updatePending}
        confirmText='OK'>
        <p>
          Toggling this option off will remove the View Routes section from the mobile home page. Make sure you have routes linked in the guide section before doing so.
        </p>
        {updateError && <div className={errorMessage}>
          Oops, we encountered an error while updating this experience. Please try again.
        </div>}
      </ConfirmationDialog>
    )
  }
}
